import Footer from "@components/Footer"
import Image from "@components/Image"
import { Box, Container } from "@components/Layout"
import { MadeInAmsterdam } from "@components/MadeInAmsterdam"
import SEO from "@components/SEO"
import { Anchor, Paragraph, TitleXL } from "@components/Typography"
import { getKontentImage, getPageByCodename } from "@lib/kontent"
import { ContactPage } from "@lib/kontent/models-deprecated/contact_page"
import { PageProps } from "@lib/types"
import { ErrorPage } from "@screens/error"
import { NextPage } from "next"
import styled from "styled-components"

const AnchorStyle = styled(Anchor)`
  display: block;
  margin: 0 auto;
  font-size: 1rem;
  line-height: 1.5rem;
`

type Props = PageProps<{ content: ContactPage }>

const Contact: NextPage<Props> = ({ statusCode, data }) => {
  if (statusCode || !data) {
    return <ErrorPage statusCode={statusCode} />
  }

  return (
    <>
      <SEO
        title={data.content.seoMetaTitle.value}
        description={data.content.seoMetaDescription.value}
        imageUrl={data.content.seoMetaImage.value[0]?.url}
        urlKey="contact"
      />
      <Box width="100%" py={120} bg="white">
        <Container textAlign="center" maxWidth="320px">
          <TitleXL>{data.content.pageIntroTitle.value}</TitleXL>
          <Paragraph style={{ whiteSpace: "pre-wrap", marginBottom: "1rem" }}>
            {data.content.pageIntroText.value}
          </Paragraph>
          <Box display="flex" flexDirection="column">
            <AnchorStyle href={`tel: ${data.content.phoneNumber.value}`}>
              {data.content.phoneNumber.value}
            </AnchorStyle>
            <AnchorStyle href={`mailto: ${data.content.emailAddress.value}`}>
              {data.content.emailAddress.value}
            </AnchorStyle>
          </Box>
        </Container>

        <Box position="relative" pt={["90px", "60px"]} mt={["4", "5"]}>
          {data.content.pageIntroHero.value[0] && (
            <Image
              variant="full-width"
              src={getKontentImage(data.content.pageIntroHero.value[0].url, {
                width: 1400,
              })}
              alt="background"
            />
          )}

          <Box
            maxWidth="180px"
            bg="white"
            p="2"
            m="0 auto"
            position="absolute"
            left="0"
            right="0"
            top="0"
          >
            <MadeInAmsterdam short />
          </Box>
        </Box>
      </Box>

      <Footer />
    </>
  )
}

Contact.getInitialProps = async ({ lang }) => {
  try {
    const content = await getPageByCodename({ codename: "contact", lang })
    if (!content) {
      return { statusCode: 404 }
    }
    return {
      data: { content: content.item as ContactPage },
    }
  } catch (error) {
    console.error(error)
    return { statusCode: 500 }
  }
}

export default Contact
